import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import UseOrgDefaultClassificationLevelIdQuery, {
	type useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$data,
	type useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$variables,
} from '../hooks/__generated__/useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery.graphql.ts';

export function preloadOrgDefaultClassificationLevelIdQuery() {
	return query<
		useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$data,
		useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery$variables
	>({
		query: UseOrgDefaultClassificationLevelIdQuery,
	});
}
